import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const airbase = defineConnector({
  identifier: "airbase",
  name: "Airbase",
  tagLine: "Spend management and procurement",
  logo,
  tags: ["productivity", "data"],
  defaultUrlPattern: () => "https://api\\.airbase\\.io/.*",
  protocol: "http",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Generate an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Airbase, go to **Settings > Integrations > API** and generate a new API key. You need admin permissions to do this.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
});
